import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, ModalBody, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import insertlogo from '../../Assets/App_icon/insert.png';
import backlogo from '../../Assets/App_icon/back.png';


const PurchaseMaster = () => {
  
  const store = localStorage.getItem('store');
  const host_url = localStorage.getItem('host_url');
  const user_role = localStorage.getItem('user_role');

  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false); 
  const [addmodalVisible, setAddModalVisible] = useState(false);
  const [prdmodalVisible, setPrdModalVisible] = useState(false);  
  const [addPrdmodalVisible, setAddPrdModalVisible] = useState(false);      
  

  const [wateg, setWateg] = useState([]);
  const [selectedSW, setSelectedSW] = useState([]);
 
  const [selectedWastegDetail, setSelectedWastegDetail] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState('');
  const [purLastRate, setPurLastRate] = useState('');
  
  
  const [catList, setCatList] = useState([]);
  const [selectedCatList, setSelectedCatList] = useState('');
  const [productList, setProductList] = useState([]);
  const [selectedAddProductId, setSelectedAddProductId] = useState('');
  const [selectedAddProductQty, setSelectedAddProductQty] = useState('');
  const [selectedAddProductAmt, setSelectedAddProductAmt] = useState('');
  
  const [accList, setAccList] = useState([]);
  const [accSelected, setAccSelected] = useState('');
  
  const today = new Date().toISOString().split("T")[0];
  const [entryDate, setEntryDate] = useState(today);


  const handleBack = () => {
    navigate('../dashboard');
  };

    // Escape key press handling
    useEffect(() => {
      const handleKeyPress = (event) => {
        if (event.key === "Escape") {
          // Close modal or navigate back if no modal is open
          if (modalVisible || addmodalVisible) {
            if (prdmodalVisible || addPrdmodalVisible) {
              setPrdModalVisible(false);
              setAddPrdModalVisible(false);
            } else {
              setModalVisible(false);
              setAddModalVisible(false);
            }
          } else {
            handleBack();
          }
        }
        
        if (event.key === "Insert") {
          if (modalVisible) {
            setSelectedAddProductId('');
            setSelectedAddProductQty('');
            setSelectedAddProductAmt('');
            setAddPrdModalVisible(true);
          } else {
            if(addmodalVisible) {
              setAddPrdModalVisible(true);
            } else {
              setAddModalVisible(true);
            }
          }
        }
      };

      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, [modalVisible, addmodalVisible, prdmodalVisible, addPrdmodalVisible]);

    useEffect(() => { 
      const fetchPurchaseList = async () => { 
          try {
            const response = await fetch(`${host_url}/wasteg_mlist`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                wdetail: '',
              }),
            });
            const data = await response.json();
            setWateg(data);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
          
      }; 
     fetchPurchaseList(); 
    }, [host_url, selectedWastegDetail]); // Wasteg List
     
    useEffect(() => { 
      const fetchCatagoryList = async () => { 
          try {
            const response = await fetch(`${host_url}/category`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                lang: 'Gujarati',
                store: store,
              }),
            });
            
            const data = await response.json();
            setCatList(data);
            setSelectedCatList(data[0].pcat_id)
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
      }; 
     fetchCatagoryList(); 
    }, [host_url, store]);  // Category List

    useEffect(() => { 
      const fetchProductList = async () => { 
          try {
            const response = await fetch(`${host_url}/product`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                lang: 'Gujarati',
                store: store,
                pcatId: selectedCatList ,
              }),
            });            
            const data = await response.json();
            if(data.length > 0 ) {
              setProductList(data);
            }
            
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
       
      }; 
     fetchProductList(); 
    }, [selectedCatList]);  // Product List

    useEffect(() => { 
      const fetchProductList = async () => { 
          try {
            const response = await fetch(`${host_url}/purchase_last_rate`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                lang: 'Gujarati',
                store: store,
                prdId: selectedAddProductId,
              }),
            });            
            const data = await response.json();
            setPurLastRate(data[0].pur_rate);           
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
       
      }; 
      if(selectedAddProductId){
          setPurLastRate('');
          fetchProductList(); 
      }
     
    }, [selectedAddProductId]);  // Last Purchase Rate Fetch

        
    useEffect(() => { 
      
        const accountDetail = {
            acc_type: 'Pur_Party',
        };
        const fetchAccountDetail = async () => { 
          try {
            const response = await fetch(`${host_url}/account_select`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                accDetail: accountDetail,
              }),
            });            
            const data = await response.json();
            setAccList(data);              
           
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
        }; 
       fetchAccountDetail();  
    }, [addmodalVisible]); // Account Detail

   

    const sdate = new Date();
    sdate.setMonth(sdate.getMonth() - 3);
    sdate.setDate(1);
    const ThreeMonthAgo = sdate.toISOString().split("T")[0];
    
    const [startDate, setStartDate] = useState(ThreeMonthAgo);
    const [endDate, setEndDate] = useState(today);
    const [catNameFilter, setCatNameFilter] = useState('');
    const [prdNameFilter, setPrdNameFilter] = useState('');

    const filteredWasteg = wateg.filter(data =>{
      const swEntryDate = new Date(data.sw_date); 
      const start = startDate ? new Date(startDate) : null;
      if (start) {
        start.setDate(start.getDate() - 1); // Subtract 1 day
      }
      const end = endDate ? new Date(endDate) : null;
      
      return (
        String(data.pcat_id).toLowerCase().includes(catNameFilter.toLowerCase()) && 
        data.prd_name.toLowerCase().includes(prdNameFilter.toLowerCase()) &&
        (!start || swEntryDate >= start) && 
        (!end || swEntryDate <= end)
      );
    });

    const totalCount = filteredWasteg.length;
    const totalWategQty = filteredWasteg.reduce((sum, data) => sum + Number(data.sw_prd_qty), 0);
    const totalWategAmt = filteredWasteg.reduce((sum, data) => sum + Number(data.sw_prd_amt), 0);

    const detailtotalWeight = selectedWastegDetail.reduce((sum, product) => sum + Number(product.prd_qty), 0);
    const detailtotalAmt = selectedWastegDetail.reduce((sum, product) => sum + Number(product.prd_amt), 0);

    

    const handleWastegDetail = async (row) => {
      setModalVisible(true);
      setSelectedSW({
          ...row,
          sw_prd_rate: parseFloat((Number(row.sw_prd_amt) / Number(row.sw_prd_qty)).toFixed(2))

      });
      setSelectedCatList(row.pcat_id);
      setSelectedWastegDetail([]);
      console.log(row);
      
    };

    const handleDelete = async () => {
        const userConfirmed = window.confirm('Are you sure you want to delete this Entry?');
        if (userConfirmed) {
            setModalVisible(false);
            const AddDetail = {
                sw_id: selectedSW.sw_id,
                sw_prd_id: selectedSW.sw_prd_id,
                sw_prd_qty: selectedSW.sw_prd_qty || 0,
                sw_prd_amt: selectedSW.sw_prd_amt || 0,
            };
            
            try {
              const response = await fetch(`${host_url}/wasteg_mlist`, {
                method: 'POST', 
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  type: 'wasteg_delete', 
                  store: store, 
                  wdetail: AddDetail,
                }),
              });
              const data = await response.json();
              setWateg(data);
              setSelectedSW([]);

                     
            } catch (error) {
              console.error('Error fetching cities:', error);
            }  
         }
         
        
    };

    
    const handleAddWasteg = async () => {
      if (selectedAddProductId) {
        const today = new Date().toISOString().split('T')[0];
        const AddDetail = {
            sw_date: today,
            sw_prd_id: selectedAddProductId,
            sw_prd_qty: selectedAddProductQty || 0,
            sw_prd_amt: (Math.round((selectedAddProductQty || 0) * (purLastRate || 1)) || 0),
        };

        try {
          const response = await fetch(`${host_url}/wasteg_mlist`, {
            method: 'POST', 
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              type: 'wasteg_Insert',
              store: store,
              wdetail: AddDetail,
            }),
          });
          const data = await response.json();
          setWateg(data);
          setSelectedAddProductId('');
          setPurLastRate('');
          setSelectedAddProductQty('');
          setAddModalVisible(false);
        } catch (error) {
          console.error('Error fetching cities:', error);
        }                 
      } 
    };

    const handleSubmit = async () => {
      setModalVisible(false);
      const today = new Date().toISOString().split('T')[0];
      const AddDetail = {
          sw_id: selectedSW.sw_id,
          sw_date: today,
          sw_prd_id: selectedSW.sw_prd_id,
          sw_prd_qty: selectedSW.sw_prd_qty || 0,
          sw_prd_amt: (Math.round(selectedSW.sw_prd_qty * selectedSW.sw_prd_rate) || 0),
      };
      
      try {
        const response = await fetch(`${host_url}/wasteg_mlist`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'wasteg_Update', 
            store: store, 
            wdetail: AddDetail,
          }),
        });
        const data = await response.json();
        setWateg(data);
        setSelectedSW([]);
               
      } catch (error) {
        console.error('Error fetching cities:', error);
      } 
    };


    const handleProduct = async (row) => {
      setPrdModalVisible(true);
      setSelectedProduct(row);
      setSelectedCatList(row.pcat_id); 
    };
    
  return (
    <div className="container">
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div onClick={handleBack}>
                <img src={backlogo} alt="Back" className='system-icon'/>
              </div>
              <b style={{ margin: '10px', fontSize: '20px' }}>Wasteg Master</b>
                <div onClick={(e) => { setSelectedAddProductId(''); setSelectedAddProductQty(''); setAddModalVisible(true);}}>
                  <img src={insertlogo} alt="Back" className='system-icon'/>
                </div>
          </div>
        
          <table className="table-bordered table-sm custom-hover">
            <thead>
              <tr >        
                <th ><input type="date" className='search-input no-icon' style={{ textAlign: 'center' }} value={startDate} onChange={(e) => setStartDate(e.target.value)} /></th>
                <th colSpan='2'>Product</th>
                <th colSpan='2'>Category</th>
                <th >Qty</th>
                <th >Rate</th>
                <th >Amount</th>
              </tr>
              <tr>
                <th ><input type="date" className='search-input no-icon' style={{ textAlign: 'center' }} value={endDate} onChange={(e) => setEndDate(e.target.value)} /></th>
                <th colSpan='2'>
                  <select
                    className="search-input"
                    value={catNameFilter}
                    onChange={(e) => { setSelectedCatList(e.target.value); setCatNameFilter(e.target.value) }}
                  >
                    <option value="">All Category</option>
                    {catList.map((catList) => (
                      catList.pcat_count > 0 && (
                        <option key={catList.pcat_Id} value={catList.pcat_id}>
                          {catList.pcat_name}
                        </option>
                      )
                    ))}
                  </select>
                </th>
                <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={prdNameFilter}
                    onChange={(e) => setPrdNameFilter(e.target.value)}
                  />
                </th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody className="scrollable-body">
              {filteredWasteg.map((row, index) => {
                  return (
                    <tr key={index} style={{ lineHeight: '10px' }} onClick={() => handleWastegDetail(row)}>
                      <td > {new Date(row.sw_date).toLocaleDateString("en-GB").replace(/\//g, "-")}</td>
                      <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }} >{row.pcat_name}</span></td>
                      <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px' }}>{row.prd_name}</span></td>
                      <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.sw_prd_qty}</span></td>
                      <td className="cell-right"><span style={{ paddingRight: '10px' }}>{(row.sw_prd_amt / row.sw_prd_qty).toFixed(2)}</span></td>
                      <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.sw_prd_amt}</span></td>
                    </tr>
                  );
              })}
            </tbody>
            <tfoot>
              <tr >
                <th className="cell-left" ><span style={{ paddingLeft: '10px' }}>{totalCount}</span></th>
                <th colSpan='2' className="cell-left" ><span style={{ paddingLeft: '10px' }}></span></th>
                <th colSpan='2' className="cell-left" ><span style={{ paddingLeft: '10px' }}></span></th>
                <th className="cell-right" ><span style={{ paddingRight: '10px' }}>{totalWategQty}</span></th>
                <th className="cell-right" ><span ></span></th>
                <th className="cell-right" ><span style={{ paddingRight: '10px' }}>{totalWategAmt}</span></th>
              </tr>
            </tfoot>
          </table>
          

          {/* Modal for Purchase Detail */}
            <Modal isOpen={modalVisible} toggle={() => setModalVisible(!modalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>  
                  <div>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tbody>
                        <tr>
                          <td className='cell-left'>Catagory</td>
                          <td style={{ padding: '2px' }} >
                              <select
                                value={selectedSW.pcat_id}
                                onChange={(e) => setSelectedSW({ ...selectedSW, pcat_id: e.target.value })}
                              >
                                {catList.map((catList, index) => (
                                    <option key={index} value={catList.pcat_id}>
                                      {catList.pcat_name}
                                    </option>
                                ))}
                              </select>
                          </td>    
                        </tr>
                        <tr>
                          <td className='cell-left'>Product</td>
                          <td style={{ padding: '2px' }} >
                              <select
                                value={selectedSW.sw_prd_id}
                                onChange={(e) => setSelectedSW({ ...selectedSW, sw_prd_id: e.target.value })}
                              >
                                <option key='' value=''>Select Product</option>
                                {productList.map((plist, index) => (
                                    <option key={index} value={plist.prd_id}>
                                      {plist.prd_name} 
                                    </option>
                                ))}
                              </select>
                          </td>    
                        </tr>
                        <tr>
                          <td className='cell-left'>Qty</td>
                          <td style={{ padding: '2px' }} >
                            <input
                              type="text"
                              value={selectedSW.sw_prd_qty}
                              onChange={(e) => setSelectedSW({ ...selectedSW, sw_prd_qty: e.target.value })}
                            />
                          </td>  
                        </tr>
                        <tr>
                            <td className='cell-left'>Rate</td>
                            <td style={{ padding: '2px' }} >
                              <input
                                type="text"
                                value={selectedSW.sw_prd_rate}
                                onChange={(e) => setSelectedSW({ ...selectedSW, sw_prd_rate: e.target.value })}
                              />
                          </td>  
                        </tr>
                        <tr>
                            <td className='cell-left'>Amount</td>
                            <td className='cell-left' style={{ paddingLeft: '10px' }} > {Math.round(selectedSW.sw_prd_qty * selectedSW.sw_prd_rate)}</td> 
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', margin: '0 auto' }}>
                    <Button color="danger" style={{ flex: 1, marginLeft: '10px'}} onClick={handleDelete}  disabled={user_role !== 'Admin' }>
                      Delete 
                    </Button>
                    <Button color="success" style={{ flex: 1, marginLeft: '10px', marginRight: '10px' }} onClick={handleSubmit}>
                      Update 
                    </Button>
                    <Button color="primary" style={{ flex: 1, marginRight: '10px' }} onClick={() => setModalVisible(false)}>
                      Close
                    </Button>
                  </div>
              </ModalBody>
            </Modal>

          {/* Modal for Add Product Detail */}
            <Modal isOpen={addmodalVisible} toggle={() => setModalVisible(!addmodalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>  
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tbody>
                        <tr>
                          <td className='cell-left'>Catagory</td>
                          <td style={{ padding: '2px' }} >
                              <select
                                value={selectedCatList}
                                onChange={(e) => setSelectedCatList(e.target.value)}
                              >
                                {catList.map((catList, index) => (
                                    <option key={index} value={catList.pcat_id}>
                                      {catList.pcat_name}
                                    </option>
                                ))}
                              </select>
                          </td>    
                        </tr>
                        <tr>
                          <td className='cell-left'>Product</td>
                          <td style={{ padding: '2px' }} >
                              <select
                                onChange={(e) => setSelectedAddProductId(e.target.value)}
                              >
                                <option key='' value=''>Select Product</option>
                                {productList.map((plist, index) => (
                                    <option key={index} value={plist.prd_id}>
                                      {plist.prd_name} 
                                    </option>
                                ))}
                              </select>
                          </td>    
                        </tr>
                        <tr>
                          <td className='cell-left'>Qty</td>
                          <td style={{ padding: '2px' }} >
                            <input
                              type="text"
                              value={selectedAddProductQty}
                              onChange={(e) => setSelectedAddProductQty(e.target.value)}
                            />
                          </td>  
                        </tr>
                        <tr>
                            <td className='cell-left'>Rate</td>
                            <td style={{ padding: '2px' }} >
                              <input
                                type="text"
                                value={purLastRate}
                                onChange={(e) => setPurLastRate(e.target.value)}
                              />
                          </td>  
                        </tr>
                        <tr>
                            <td className='cell-left'>Amount</td>
                            <td className='cell-left' style={{ paddingLeft: '10px' }} > {Math.round(selectedAddProductQty * purLastRate)}</td> 
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleAddWasteg} disabled={!selectedAddProductQty || !selectedAddProductId}>
                      Add Product
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setAddModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>        
    </div>
  );
};

export default PurchaseMaster;
